import { render } from "./naik-pangkat-list-custom.vue?vue&type=template&id=c64745d8"
import script from "./naik-pangkat-list-custom.vue?vue&type=script&lang=js"
export * from "./naik-pangkat-list-custom.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__